



































// 3rd party
import {
    mapGetters,
    mapActions,
} from 'vuex';

import {
    CountryIso2,
} from '@shared/types/registration';
import Vue from 'vue';

export default Vue.extend({
    name: 'us-vat-state-needed-modal',
    props: {
        ctaOpts: {
            type: Object,
            required: true,
            default: () => ({
                text: '',
                callback: null,
            }),
        },
    },
    data() {
        return {
            states: [],
            selectedState: {
                state: {},
            },
        };
    },
    computed: {
        ...mapGetters('countries', ['countriesList', 'getStates']),

        isStateCorrectlySet() {
            if (!this.selectedState.state || !Object.keys(this.selectedState.state).length) {
                return false;
            }

            return Boolean(this.selectedState.state &&
                Object.keys(this.selectedState.state).length);
        },

        showStateDropdown() {
            return this.states?.length;
        },
    },
    async created() {
        const Usa = this.countriesList.find((country) => country.iso2 === CountryIso2.USA);

        await this.fetchCountryStates({
            countryId: Usa.id,
        });
        this.states = this.getStates.map((stateData) => ({
            ...stateData,
            display: stateData.state,
        }));
    },
    methods: {
        ...mapActions('countries', ['fetchCountryStates']),

        onClickCta(): void {
            if (this.ctaOpts.callback) {
                this.ctaOpts.callback(this.selectedState);
            }
        },
    },
});
